import React from "react";

const V = {
  primary:   "text-white border-0 bg-gradient-to-br from-p to-[#1E3A8A] shadow-[0_2px_6px_rgba(37,99,235,0.35)] hover:shadow-[0_4px_10px_rgba(37,99,235,0.45)]",
  secondary: "bg-bg1 text-t0 border border-b1 hover:border-p hover:text-p",
  ghost:     "bg-transparent text-t1 border-0 hover:text-p hover:bg-pg",
  danger:    "bg-rb text-r border border-rd",
  success:   "bg-gb text-g border border-gd",
  // Amber tint — softer than danger, used for "warning but not blocking"
  // actions like Mark Not Joined (candidate accepted the offer but didn't join).
  warning:   "bg-ab text-a border border-ad",
};
const S = { xs: "px-[6px] py-[2px] text-[12px]", sm: "px-[10px] py-[4px] text-[14px]", md: "px-[14px] py-[7px] text-[14px]" };
const IS = { xs: 9, sm: 10, md: 12 };

export const Bt = ({ children, v = "primary", s = "md", icon: Ic, onClick, disabled, full, style: st }) => (
  <button
    disabled={disabled}
    onClick={onClick}
    style={st}
    className={`inline-flex items-center justify-center gap-[5px] rounded-[10px] font-bold transition-all duration-150 ${V[v] || V.primary} ${S[s] || S.md} ${disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer opacity-100"} ${full ? "w-full" : "w-auto"}`}
  >
    {Ic && <Ic size={IS[s] || 12} />}
    {children}
  </button>
);
